import { SETTING_DEFS } from "@gaole/shared";
import { Button, Input, SettingsCard } from "../../components/ui";
import { settingsTabLabel } from "../../config/admin-settings";

const CREDITS_KEYS = SETTING_DEFS.filter((d) => d.group === "credits").map((d) => d.key);

interface CreditsSettingsEditorProps {
  draft: Record<string, unknown>;
  setValue: (key: string, value: unknown) => void;
  saveMut: { mutate: (keys: string[]) => void; isPending: boolean };
}

export function CreditsSettingsEditor({ draft, setValue, saveMut }: CreditsSettingsEditorProps) {
  return (
    <div className="w-full min-w-0 space-y-5">
      <div>
        <h1 className="font-display text-lg font-bold">{settingsTabLabel("credits")}</h1>
        <p className="mt-0.5 text-xs text-muted">Conversion rate and wallet top-up packages.</p>
      </div>

      <SettingsCard
        title="Credits"
        footer={
          <div className="flex justify-end">
            <Button size="sm" disabled={saveMut.isPending} onClick={() => saveMut.mutate(CREDITS_KEYS)}>
              Save
            </Button>
          </div>
        }
      >
        <Input
          label="Credits per 1 MYR"
          type="number"
          step="0.01"
          value={
            draft["credits.conversion_rate"] === "" || draft["credits.conversion_rate"] == null
              ? ""
              : String(draft["credits.conversion_rate"])
          }
          onChange={(e) =>
            setValue("credits.conversion_rate", e.target.value)
          }
          hint="How many credits customers receive per 1 MYR spent or paid."
        />
      </SettingsCard>
    </div>
  );
}

export { CREDITS_KEYS };
